package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Badge
import co.maytes.standupbot.dashboard.components.widgets.BadgeTone
import co.maytes.standupbot.shared.dto.standup.LinkStateDto

@Composable
fun LinkStateChip(provider: String, state: LinkStateDto) {
    Badge(label = "$provider ${state.chipText()}", tone = state.chipTone())
}

private fun LinkStateDto.chipText(): String =
    when (this) {
        LinkStateDto.LINKED -> "✓"
        LinkStateDto.MISSING -> "no match"
        LinkStateDto.AMBIGUOUS -> "ambiguous"
        LinkStateDto.NOT_CONNECTED -> "not connected"
        LinkStateDto.ERROR -> "error"
    }

private fun LinkStateDto.chipTone(): BadgeTone =
    when (this) {
        LinkStateDto.LINKED -> BadgeTone.Success
        LinkStateDto.MISSING, LinkStateDto.AMBIGUOUS -> BadgeTone.Warning
        LinkStateDto.NOT_CONNECTED -> BadgeTone.Neutral
        LinkStateDto.ERROR -> BadgeTone.Error
    }
